<template>
   <Card :dis-hover="true">
        <Tabs v-model="userType"
            :animated="false"
            :capture-focus="true">
            <TabPane label="外部客户"
                name="externalCustomer">
                <ExternalCustomerUserList 
                    v-if="userType === 'externalCustomer'" />
            </TabPane>
            <TabPane label="内部客户"
                name="binfenCustomer">
                <BinFenCustomerUserList
                    v-if="userType === 'binfenCustomer'" />
            </TabPane>
            <TabPane label="查找客户"
                name="CustomerSearch">
                <CustomerSearchList/>
            </TabPane>
            <TabPane label="客户信息操作日志" name="CustomerLog">
                <CustomerLogList v-if="userType === 'CustomerLog'" />
            </TabPane>
        </Tabs>
    </Card>
	<!-- <Card>
		<Row :gutter="16">
			<Col span="24" label="客户" name="externalCustomer">
		<div class="global-tool-bar">
		<ExternalCustomerUserList  v-model="userType"
			ref="xternalCustomerUserList" />
		</div>
	    </Col>
	</Row> -->

</template>

<script>

import BinFenCustomerUserList from '@/view/account-management/binFenCustomer-user-management/binFenCustomer-user-list';
import ExternalCustomerUserList from '@/view/account-management/externalCustomer-user-management/externalCustomer-user-list';
import CustomerSearchList from '@/view/account-management/customer-search-management/customer-search-list';
import CustomerLogList from '@/view/account-management/customer-user-log-management/customer-user-log-list';
export default {
    name: 'UserList',
    components: {
        BinFenCustomerUserList,
        ExternalCustomerUserList,
        CustomerSearchList,
        CustomerLogList
    },
    data() {
        return {
            userType: "externalCustomer"
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
